import * as React from "react";
import { useLayoutEffect, useState } from "react";
import { MainContainer } from "./styles";
import { ThemeProvider } from "@mui/material/styles";

import Header from "components/Header";
import theme from "theme/theme";
import { Box } from "@mui/material";
import { useRealtimeSocket } from "hooks/useRealtimeSocket";
import { ChatUnreadProvider } from "context/ChatUnreadContext";
import { NotificationUnreadProvider } from "context/NotificationUnreadContext";
import { ChatUnreadSocketListener } from "components/Chat/ChatUnreadSocketListener";
import { NotificationUnreadSocketListener } from "components/Notification/NotificationUnreadSocketListener";

type ContainerProps = {
  children: React.ReactNode;
};

const Container: React.FC<ContainerProps> = ({ children }) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const { connected: socketConnected } = useRealtimeSocket();

  useLayoutEffect(() => {
    document.body.style.setProperty("overflow", "auto", "important");
    document.body.style.paddingRight = "";
    document.documentElement.style.setProperty("overflow", "auto", "important");
  });

  const handleDrawerMenuOpen = () => {
    setMenuIsOpen(!menuIsOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <MainContainer>
        <ChatUnreadProvider socketConnected={socketConnected}>
          <NotificationUnreadProvider socketConnected={socketConnected}>
            <ChatUnreadSocketListener />
            <NotificationUnreadSocketListener />
            <Header
              isDrawerMenuOpen={menuIsOpen}
              handleDrawerMenuOpen={handleDrawerMenuOpen}
            />
            <Box>{children}</Box>
          </NotificationUnreadProvider>
        </ChatUnreadProvider>
      </MainContainer>
    </ThemeProvider>
  );
};

export default Container;
